<template>
  <div>
    <div class="btn-voltar">
      <v-btn color="primary" flat depressed @click="retornar">
        <v-icon>chevron_left</v-icon>
        Voltar para listagem
      </v-btn>
    </div>

    <az-container>
      <div v-if="temMaisDeUmLote" class="sessao-seletor-lote">
          <v-btn class="btn-seletor-lote" small flat :disabled="indiceLoteSelecionado === 0" @click="selecionarItemAnterior">
            <v-icon small color="primary">chevron_left</v-icon>
          </v-btn>

          <v-select class="seletor-lote"
              :items="opcoesLote"
              v-model="indiceLoteSelecionado"
              item-text="text"
              item-value="value"
              hide-details
              dense
              flat
              solo
          />

          <v-btn class="btn-seletor-lote" small flat :disabled="indiceLoteSelecionado === lotes.length - 1" @click="selecionarProximoItem">
            <v-icon small color="primary">chevron_right</v-icon>
          </v-btn>
      </div>

      <div class="mt-4 px-4">
        <v-progress-circular
            v-if="loadingImage"
            indeterminate
            color="primary"
            class="ma-2"
        />
        <az-thumbnails-bar
            v-else
            :imagens="imagensFormatadas"
            :thumbnail-width="180"
            :thumbnail-height="120"
            :centralizar-imagens="false"
            :showArrows="false"
            @select="abrirCarouselImagens"
            theme="light"
        />
      </div>

      <v-divider class="my-4"/>

      <div class="info-resumo">
        <div class="info-resumo__item mr-5 mb-3">
          <div class="info-resumo__label">Situação</div>
          <div class="info-resumo__valor">{{ situacaoFormatada }}</div>
        </div>

        <div class="info-resumo__item mr-5 mb-3">
          <div class="info-resumo__label">Tipo</div>
          <div class="info-resumo__valor">{{ tipoFormatado }}</div>
        </div>

        <div class="info-resumo__item mb-3">
          <div class="info-resumo__label">Valor Mínimo</div>
          <div class="info-resumo__valor">{{ valorMinimoFormatado }}</div>
        </div>
      </div>

      <div class="titulo-detalhes mb-2">Detalhes do Item</div>

      <v-data-table
          :headers="colunas"
          :items="itensLoteSelecionado"
          :total-items="itensLoteSelecionado.length"
          :loading="false"
          hide-actions
          no-data-text="Não há itens do grupo disponíveis"
          class="az-table-list tabela-detalhes"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>{{ props.item.sequencia || '-' }}</td>
            <td>{{ props.item.descricao || '-' }}</td>
            <td>{{ props.item.unidade || '-' }}</td>
            <td>
              <formatador-moeda
                  v-if="possuiQuantidade(props.item.quantidade)"
                  :valor="Number(props.item.quantidade)"
                  :casas-decimais="casasDecimaisQuantidade"
              />
              <span v-else>-</span>
            </td>
            <td></td>
          </tr>
        </template>
      </v-data-table>
    </az-container>

    <imagem-carousel-dialog
        :fullscreen="true"
        ref="imagemCarouselDialog"
        :imagensProp="imagens"
    />
  </div>
</template>
<script>
import AzThumbnailsBar from '@/views/components/AzThumbnailsBar.vue'
import {actionTypes} from '@/core/constants'
import ImagemCarouselDialog from '@/views/components/ImagemCarouselDialog.vue'
import FormatadorMoeda from '@/views/components/FormatadorMoeda.vue'
import {normalizarCasasDecimais} from '@/core/utils/CasasDecimaisUtils'

export default {
    name: 'LicitacaoVisualizacaoDetalhesLote',
    components: {FormatadorMoeda, ImagemCarouselDialog, AzThumbnailsBar},

    data() {
        return {
            licitacaoId: null,
            lotes: [],
            imagens: [],
            loadingImage: false,
            cacheImagensPorItemId: {},
            cacheImagensPorLoteId: {}
        }
    },
    computed: {
        casasDecimaisQuantidade() {
            const licitacao = (this.$store && this.$store.state && this.$store.state.licitacao) || {}
            return normalizarCasasDecimais(licitacao.casasDecimaisQuantidade)
        },
        colunas() {
            return [
                {
                    value: 'sequencia',
                    text: 'Item',
                    align: 'left',
                    width: '10%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'descricao',
                    text: 'Descrição',
                    align: 'left',
                    width: '30%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'unidade',
                    text: 'Unidade',
                    align: 'left',
                    width: '10%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'quantidade',
                    text: 'Qtd.',
                    align: 'left',
                    width: '10%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: '',
                    text: '',
                    align: 'right',
                    width: '40%',
                    sortable: false,
                    class: 'primary--text'
                },
            ]
        },
        temMaisDeUmLote() {
            return this.lotes.length > 1
        },
        indiceLoteSelecionado: {
            get() {
                if (!this.lotes.length) return 0

                const loteIdRota = this.normalizarLoteId(this.$route.query.loteId)
                const indice = this.lotes.findIndex(lote => this.normalizarLoteId(lote.loteId) === loteIdRota)

                return indice >= 0 ? indice : 0
            },
            set(novoIndice) {
                const lote = this.lotes[novoIndice]
                if (!lote) return

                this.atualizarRotaLote(lote.loteId)
            }
        },
        loteSelecionado() {
            return this.lotes[this.indiceLoteSelecionado] || {}
        },
        itensLoteSelecionado() {
            return this.loteSelecionado.itens || []
        },
        opcoesLote() {
            return this.lotes.map((tipo, index) => ({
                text: tipo.lote,
                value: index
            }))
        },
        situacaoFormatada() {
            return this.loteSelecionado.titulo
        },
        tipoFormatado() {
            return this.loteSelecionado.descricao
        },
        valorMinimoFormatado() {
            const valor = this.loteSelecionado.valorTotalEstimado
            if (valor === null || valor === undefined || valor === '') return '-'

            const numero = Number(valor)
            if (Number.isNaN(numero)) return valor

            return numero.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            })
        },
        imagensFormatadas() {
            return this.imagens.map(imagem => ({
                ...imagem,
                src: this.resolverSrcImagem(imagem.base64)
            }))
        }
    },
    async created() {
        await this.carregarDados()
    },
    watch: {
        '$route.params.id': {
            immediate: false,
            async handler(novoId, idAnterior) {
                if (String(novoId) === String(idAnterior)) return
                await this.carregarDados()
            }
        },
        '$route.query.loteId': {
            immediate: false,
            async handler() {
                if (!this.lotes.length) return
                await this.buscarImagens()
            }
        }
    },
    methods: {
        async carregarDados() {
            this.licitacaoId = Number(this.$route.params.id)
            this.lotes = []
            this.imagens = []
            this.loadingImage = false
            this.cacheImagensPorItemId = {}
            this.cacheImagensPorLoteId = {}

            await this.buscarAcompanhamentoLotes()
            const rotaFoiAtualizada = await this.garantirLoteValidoNaRota()
            if (rotaFoiAtualizada) return

            await this.buscarImagens()
        },
        retornar() {
            if (window.history.length > 1) {
                this.$router.back()
                return
            }
            this.$router.push({name: 'home'})
        },
        selecionarItemAnterior() {
            if (this.indiceLoteSelecionado > 0) {
                this.indiceLoteSelecionado = this.indiceLoteSelecionado - 1
            }
        },
        selecionarProximoItem() {
            if (this.indiceLoteSelecionado < this.lotes.length - 1) {
                this.indiceLoteSelecionado = this.indiceLoteSelecionado + 1
            }
        },
        possuiQuantidade(quantidade) {
            return quantidade !== null && quantidade !== undefined && quantidade !== '' && !Number.isNaN(Number(quantidade))
        },
        normalizarLoteId(loteId) {
            return loteId === null || loteId === undefined || loteId === '' ? null : String(loteId)
        },
        async atualizarRotaLote(loteId) {
            const loteIdAtual = this.normalizarLoteId(this.$route.query.loteId)
            const proximoLoteId = this.normalizarLoteId(loteId)

            if (!proximoLoteId || loteIdAtual === proximoLoteId) return

            await this.$router.replace({
                name: 'licitacaoVisualizacaoDetalhesLote',
                params: {id: this.licitacaoId},
                query: {loteId: proximoLoteId}
            })
        },
        async garantirLoteValidoNaRota() {
            if (!this.lotes.length) return false

            const loteIdRota = this.normalizarLoteId(this.$route.query.loteId)
            const loteExisteNaLista = this.lotes.some(
                lote => this.normalizarLoteId(lote.loteId) === loteIdRota
            )

            if (!loteExisteNaLista) {
                await this.atualizarRotaLote(this.lotes[0].loteId)
                return true
            }

            return false
        },
        async buscarAcompanhamentoLotes() {
            this.lotes = await this.$store.dispatch(actionTypes.BUSCAR_ACOMPANHAMENTO, this.licitacaoId)
        },
        async buscarImagens() {
            const loteId = this.normalizarLoteId(this.loteSelecionado.loteId)
            const itens = this.itensLoteSelecionado || []

            this.imagens = []

            if (!loteId || !itens.length) {
                return
            }

            const cacheImagensLote = this.cacheImagensPorLoteId[loteId]
            if (cacheImagensLote) {
                this.imagens = [...cacheImagensLote]
                return
            }

            this.loadingImage = true

            try {
                const imagensLote = []

                for (const item of this.itensLoteSelecionado) {
                    const cacheImagensItem = this.cacheImagensPorItemId[item.itemId]

                    if (cacheImagensItem && cacheImagensItem.length) {
                        imagensLote.push(...cacheImagensItem)
                        continue
                    }

                    const lista = await this.$store.dispatch(
                        actionTypes.BUSCAR_IMAGENS_ITEM_BASE64,
                        {itemId: item.itemId}
                    )

                    var imagensArray = Array.isArray(lista) ? lista : []
                    if (imagensArray.length) {
                        imagensArray = this.setDescricaoImagens(imagensArray, item)
                    }
                    this.$set(this.cacheImagensPorItemId, item.itemId, imagensArray)
                    imagensLote.push(...imagensArray)
                }

                this.$set(this.cacheImagensPorLoteId, loteId, [...imagensLote])
                this.imagens = imagensLote
            } catch (error) {
                this.imagens = []
            } finally {
                this.loadingImage = false
            }
        },
        setDescricaoImagens(imagens, item) {
            return imagens.map(imagem => ({
                ...imagem,
                descricaoImagem: `Item ${item.sequencia} - ${this.loteSelecionado.numProcesso}`
            }))
        },
        resolverSrcImagem(base64) {
            if (!base64) return ''
            return `data:image/jpeg;base64,${base64}`
        },
        abrirCarouselImagens(imagem, indexInicial) {
            this.$refs.imagemCarouselDialog.open({
                index: indexInicial
            })
        },
    },
}
</script>

<style scoped lang="stylus">
.btn-voltar
  margin-left: 12px
  top: 10px
  position: relative
  font-weight: bold
  font-size: 14px
  .v-btn
    padding: 0
    margin: 0
    height: 20px
    text-transform: none

.sessao-seletor-lote
  display: flex
  justify-content: center
  align-items: center

.btn-seletor-lote
  border: 1px solid #e0e0e0
  border-radius: 4px
  height: 25px
  min-height: 25px
  width: 25px
  min-width: 25px
  padding: 0

.seletor-lote
  max-width 150px

.seletor-lote /deep/ .v-input__control
  min-height: 25px !important
  font-size 12px
  font-weight 700

.seletor-lote /deep/ .v-input__slot
  min-height: 25px !important
  height: 25px !important
  margin-bottom: 0 !important
  border: 1px solid #e0e0e0
  border-radius: 4px
  padding: 0 8px !important

.seletor-lote /deep/ .v-select__slot
  height: 25px
  display: flex
  align-items: center

.seletor-lote /deep/ .v-select__selection
  color: var(--v-primary-base) !important
  font-size: 12px
  font-weight: 700

.seletor-lote /deep/ .v-input__append-inner
  margin-top: 0 !important

.info-resumo
  max-width: 700px
  display flex
  flex-wrap nowrap
  padding-inline-start 10px
  margin-bottom 16px

.info-resumo__label
  color var(--v-primary-base)
  font-size 12px
  font-weight 700
  margin-bottom 2px

.info-resumo__valor
  font-weight 400
  font-size 13px

.titulo-detalhes
  color var(--v-primary-base)
  font-weight 700
  font-size 16px

.tabela-detalhes /deep/ table tbody td
  max-width: 700px
  font-size 13px
</style>